export class InsuranceComplianceResultToLabelMap {
  constructor() {}

  generalLiability_amBestRating: {
    label: 'AM Best Rating';
    finding: 'amBestRating';
    setting: 'generalLiability_amBestRating';
  } = {
    label: 'AM Best Rating',
    finding: 'amBestRating',
    setting: 'generalLiability_amBestRating'
  };
  generalLiability_financialSizeCategory: {
    label: 'AM Best Financial Size Category';
    finding: 'financialSize';
    setting: 'generalLiability_financialSizeCategory';
  } = {
    label: 'AM Best Financial Size Category',
    finding: 'financialSize',
    setting: 'generalLiability_financialSizeCategory'
  };
  generalLiability_policyAmountPerOccurance: {
    label: 'Policy Per Occurrence Limit';
    finding: 'perOccurence';
    setting: 'generalLiability_policyAmountPerOccurance';
  } = {
    label: 'Policy Per Occurrence Limit',
    finding: 'perOccurence',
    setting: 'generalLiability_policyAmountPerOccurance'
  };
  generalLiability_policyAmountAggregate: {
    label: 'Policy Amount Aggregate';
    finding: 'aggregate';
    setting: 'generalLiability_policyAmountAggregate';
  } = {
    label: 'Policy Amount Aggregate',
    finding: 'aggregate',
    setting: 'generalLiability_policyAmountAggregate'
  };
  generalLiability_productOps: {
    label: 'Prod-Comp/Op Aggregate';
    finding: 'productOps';
    setting: 'generalLiability_productOps';
  } = {
    label: 'Prod-Comp/Op Aggregate',
    finding: 'productOps',
    setting: 'generalLiability_productOps'
  };
  generalLiability_medicalExpenses: {
    label: 'Medical Expenses';
    finding: 'medicalExpenses';
    setting: 'generalLiability_medicalExpenses';
  } = {
    label: 'Medical Expenses',
    finding: 'medicalExpenses',
    setting: 'generalLiability_medicalExpenses'
  };
  generalLiability_damageToRentedPremises: {
    label: 'Damage to Rented Premises';
    finding: 'damageToRented';
    setting: 'generalLiability_damageToRentedPremises';
  } = {
    label: 'Damage to Rented Premises',
    finding: 'damageToRented',
    setting: 'generalLiability_damageToRentedPremises'
  };
  generalLiability_nonOwnedAutoAmount: {
    label: 'HNO Auto Coverage';
    finding: 'nonOwnedAutoAmount';
    setting: 'generalLiability_nonOwnedAutoAmount';
  } = {
    label: 'HNO Auto Coverage',
    finding: 'nonOwnedAutoAmount',
    setting: 'generalLiability_nonOwnedAutoAmount'
  };
  personalAdvertisementInjury: {
    label: 'Personal & Advertisement Injury';
    finding: 'personalAdvInjury';
    setting: 'personalAdvertisementInjury';
  } = {
    label: 'Personal & Advertisement Injury',
    finding: 'personalAdvInjury',
    setting: 'personalAdvertisementInjury'
  };
  glIsNamed: {
    label: 'Additional Insured';
    finding: 'addlInsured';
    setting: 'glIsNamed';
  } = {
    label: 'Additional Insured',
    finding: 'addlInsured',
    setting: 'glIsNamed'
  };
  glIsAgency: {
    label: 'Waiver of Subrogation Checked';
    finding: 'subrWvd';
    setting: 'glIsAgency';
  } = {
    label: 'Waiver of Subrogation Checked',
    finding: 'subrWvd',
    setting: 'glIsAgency'
  };
  glHiredAutos: {
    label: 'Hired Autos';
    finding: 'hiredAutos';
    setting: 'generalLiability_hiredAutos';
  } = {
    label: 'Hired Autos',
    finding: 'hiredAutos',
    setting: 'generalLiability_hiredAutos'
  };
  glNonOwnedAutos: {
    label: 'Non-Owned Autos';
    finding: 'nonOwnedAutos';
    setting: 'generalLiability_nonOwnedAutos';
  } = {
    label: 'Non-Owned Autos',
    finding: 'nonOwnedAutos',
    setting: 'generalLiability_nonOwnedAutos'
  };
  generalLiability_hasAiOngoingOps: {
    label: 'A.I. Ongoing Ops?';
    finding: 'hasAiOngoingOps';
    setting: 'generalLiability_hasAiOngoingOps';
  } = {
    label: 'A.I. Ongoing Ops?',
    finding: 'hasAiOngoingOps',
    setting: 'generalLiability_hasAiOngoingOps'
  };
  generalLiability_hasAiCompOps: {
    label: 'A.I. Comp. Ops?';
    finding: 'hasAiCompOps';
    setting: 'generalLiability_hasAiCompOps';
  } = {
    label: 'A.I. Comp. Ops?',
    finding: 'hasAiCompOps',
    setting: 'generalLiability_hasAiCompOps'
  };
  generalLiability_hasPnc: {
    label: 'Primary and Non-Contributory (PNC)?';
    finding: 'hasPnc';
    setting: 'generalLiability_hasPnc';
  } = {
    label: 'Primary and Non-Contributory (PNC)?',
    finding: 'hasPnc',
    setting: 'generalLiability_hasPnc'
  };
  generalLiability_hasPolicyDoc: {
    label: 'Has Passed Full Policy Review?';
    finding: 'hasPolicyDoc';
    setting: 'generalLiability_hasFullPolicyDoc';
  } = {
    label: 'Has Passed Full Policy Review?',
    finding: 'hasPolicyDoc',
    setting: 'generalLiability_hasFullPolicyDoc'
  };
  generalLiability_hasDescOps: {
    label: 'Description of Operations Validated?';
    finding: 'hasDescOps';
    setting: 'glDescOps';
  } = {
    label: 'Description of Operations Validated?',
    finding: 'hasDescOps',
    setting: 'glDescOps'
  };
  generalLiability_hasRequiredForms: {
    label: 'Has Required Forms?';
    finding: 'hasRequiredForms';
    setting: 'generalLiability_hasRequiredForms';
  } = {
    label: 'Has Required Forms?',
    finding: 'hasRequiredForms',
    setting: 'generalLiability_hasRequiredForms'
  };
  generalLiability_isContractualLiability: {
    label: 'Contractual Liability?';
    finding: 'isContractualLiability';
    setting: 'generalLiability_contractualLiability';
  } = {
    label: 'Contractual Liability?',
    finding: 'isContractualLiability',
    setting: 'generalLiability_contractualLiability'
  };
  generalLiability_isPerOccurrence: {
    label: 'Occurrence based?';
    finding: 'isPerOccurrence';
    setting: 'generalLiability_isPerOccurrence';
  } = {
    label: 'Occurrence based?',
    finding: 'isPerOccurrence',
    setting: 'generalLiability_isPerOccurrence'
  };
  glPerProjLocAgg: {
    label: 'Per Proj/Loc Agg?';
    finding: 'perProjLocAgg';
    setting: 'generalLiability_perProjLocAgg';
  } = {
    label: 'Per Proj/Loc Agg?',
    finding: 'perProjLocAgg',
    setting: 'generalLiability_perProjLocAgg'
  };
  glAdditionalInsuredEndorsements: {
    label: 'Additional Insured Endorsement-Scheduled names?';
    finding: 'hasAdditionalInsuredEndorsements';
    setting: 'glAdditionalInsuredEndorsements';
  } = {
    label: 'Additional Insured Endorsement-Scheduled names?',
    finding: 'hasAdditionalInsuredEndorsements',
    setting: 'glAdditionalInsuredEndorsements'
  };
  generalLiability_InsNameFailed: {
    label: 'Insured Name?';
    finding: 'InsNameFailed';
    setting: 'generalLiability_InsNameFailed';
  } = {
    label: 'Insured Name?',
    finding: 'InsNameFailed',
    setting: 'generalLiability_InsNameFailed'
  };
  generalLiability_legalNameMismatch: {
    label: 'COI Name/Legal Name Mismatch?';
    finding: 'legalNameMismatch';
    setting: 'generalLiability_legalNameMismatch';
  } = {
    label: 'COI Name/Legal Name Mismatch?',
    finding: 'legalNameMismatch',
    setting: 'generalLiability_legalNameMismatch'
  };

  allowNonCommercialPolicy: {
    label: 'Is Auto a Commercial Policy?';
    finding: 'isCommercialAuto';
    setting: 'allowNonCommercialPolicy';
  } = {
    label: 'Is Auto a Commercial Policy?',
    finding: 'isCommercialAuto',
    setting: 'allowNonCommercialPolicy'
  };
  autoLiability_amBestRating: {
    label: 'AM Best Rating';
    finding: 'amBestRating';
    setting: 'autoLiability_amBestRating';
  } = {
    label: 'AM Best Rating',
    finding: 'amBestRating',
    setting: 'autoLiability_amBestRating'
  };
  autoLiability_financialSizeCategory: {
    label: 'AM Best Financial Size Category';
    finding: 'financialSize';
    setting: 'autoLiability_financialSizeCategory';
  } = {
    label: 'AM Best Financial Size Category',
    finding: 'financialSize',
    setting: 'autoLiability_financialSizeCategory'
  };
  autoLiability_combinedSingleLimit: {
    label: 'Combined Single Limit';
    finding: 'combinedSingle';
    setting: 'autoLiability_combinedSingleLimit';
  } = {
    label: 'Combined Single Limit',
    finding: 'combinedSingle',
    setting: 'autoLiability_combinedSingleLimit'
  };
  autoLiability_propertyDamageLimit: {
    label: 'Property Damage Limit';
    finding: 'propertyDamage';
    setting: 'autoLiability_propertyDamageLimit';
  } = {
    label: 'Property Damage Limit',
    finding: 'propertyDamage',
    setting: 'autoLiability_propertyDamageLimit'
  };
  autoLiability_bodilyInjuryPerPerson: {
    label: 'Bodily Injury Per Person';
    finding: 'biPerPerson';
    setting: 'autoLiability_bodilyInjuryPerPerson';
  } = {
    label: 'Bodily Injury Per Person',
    finding: 'biPerPerson',
    setting: 'autoLiability_bodilyInjuryPerPerson'
  };
  autoLiability_bodilyInjuryPerAccident: {
    label: 'Bodily Injury Per Accident';
    finding: 'biPerAccident';
    setting: 'autoLiability_bodilyInjuryPerAccident';
  } = {
    label: 'Bodily Injury Per Accident',
    finding: 'biPerAccident',
    setting: 'autoLiability_bodilyInjuryPerAccident'
  };
  autoIsNamed: {
    label: 'Additional Insured';
    finding: 'addlInsured';
    setting: 'autoIsNamed';
  } = {
    label: 'Additional Insured',
    finding: 'addlInsured',
    setting: 'autoIsNamed'
  };
  autoIsAgency: {
    label: 'Waiver of Subrogation Checked?';
    finding: 'subrWvd';
    setting: 'autoIsAgency';
  } = {
    label: 'Waiver of Subrogation Checked?',
    finding: 'subrWvd',
    setting: 'autoIsAgency'
  };
  autoHasNonOwnedAuto: {
    label: 'Hired & Non-Owned Auto Coverage?';
    finding: 'hasNonOwnedAuto';
    setting: 'autoLiability_hasNonOwnedAuto';
  } = {
    label: 'Hired & Non-Owned Auto Coverage?',
    finding: 'hasNonOwnedAuto',
    setting: 'autoLiability_hasNonOwnedAuto'
  };
  autoLiability_hasPolicyDoc: {
    label: 'Has Passed Full Policy Review?';
    finding: 'hasPolicyDoc';
    setting: 'autoLiability_hasFullPolicyDoc';
  } = {
    label: 'Has Passed Full Policy Review?',
    finding: 'hasPolicyDoc',
    setting: 'autoLiability_hasFullPolicyDoc'
  };
  autoLiability_hasDescOps: {
    label: 'Description of Operations Validated?';
    finding: 'hasDescOps';
    setting: 'autoDescOps';
  } = {
    label: 'Description of Operations Validated?',
    finding: 'hasDescOps',
    setting: 'autoDescOps'
  };
  autoLiability_hasRequiredForms: {
    label: 'Has Required Forms?';
    finding: 'hasRequiredForms';
    setting: 'autoLiability_hasRequiredForms';
  } = {
    label: 'Has Required Forms?',
    finding: 'hasRequiredForms',
    setting: 'autoLiability_hasRequiredForms'
  };
  autoAdditionalInsuredEndorsements: {
    label: 'Additional Insured Endorsement-Scheduled names?';
    finding: 'hasAdditionalInsuredEndorsements';
    setting: 'autoAdditionalInsuredEndorsements';
  } = {
    label: 'Additional Insured Endorsement-Scheduled names?',
    finding: 'hasAdditionalInsuredEndorsements',
    setting: 'autoAdditionalInsuredEndorsements'
  };
  autoLiability_InsNameFailed: {
    label: 'Insured Name?';
    finding: 'InsNameFailed';
    setting: 'autoLiability_InsNameFailed';
  } = {
    label: 'Insured Name?',
    finding: 'InsNameFailed',
    setting: 'autoLiability_InsNameFailed'
  };
  // These should only be displayed for Transporters.
  autoLiability_contingentAuto: {
    label: 'Contingent Auto?';
    finding: 'contingentAuto';
    setting: 'autoLiability_contingentAuto';
  } = {
    label: 'Contingent Auto?',
    finding: 'contingentAuto',
    setting: 'autoLiability_contingentAuto'
  };
  autoLiability_trailerInterchange: {
    label: 'Trailer Interchange';
    finding: 'trailerInterchange';
    setting: 'autoLiability_trailerInterchange';
  } = {
    label: 'Trailer Interchange',
    finding: 'trailerInterchange',
    setting: 'autoLiability_trailerInterchange'
  };
  autoLiability_cargoLiability: {
    label: 'Cargo Liability';
    finding: 'cargoLiability';
    setting: 'autoLiability_cargoLiability';
  } = {
    label: 'Cargo Liability',
    finding: 'cargoLiability',
    setting: 'autoLiability_cargoLiability'
  };
  autoLiability_legalNameMismatch: {
    label: 'COI Name/Legal Name Mismatch?';
    finding: 'legalNameMismatch';
    setting: 'autoLiability_legalNameMismatch';
  } = {
    label: 'COI Name/Legal Name Mismatch?',
    finding: 'legalNameMismatch',
    setting: 'autoLiability_legalNameMismatch'
  };

  umbrellaLiability_amBestRating: {
    label: 'AM Best Rating';
    finding: 'amBestRating';
    setting: 'umbrellaLiability_amBestRating';
  } = {
    label: 'AM Best Rating',
    finding: 'amBestRating',
    setting: 'umbrellaLiability_amBestRating'
  };
  umbrellaLiability_financialSizeCategory: {
    label: 'AM Best Financial Size Category';
    finding: 'financialSize';
    setting: 'umbrellaLiability_financialSizeCategory';
  } = {
    label: 'AM Best Financial Size Category',
    finding: 'financialSize',
    setting: 'umbrellaLiability_financialSizeCategory'
  };
  umbrellaLiability_policyAmountPerOccurance: {
    label: 'Policy Amount Per Occurrence';
    finding: 'perOccurence';
    setting: 'umbrellaLiability_policyAmountPerOccurance';
  } = {
    label: 'Policy Amount Per Occurrence',
    finding: 'perOccurence',
    setting: 'umbrellaLiability_policyAmountPerOccurance'
  };
  umbrellaLiability_policyAmountAggregate: {
    label: 'Policy Amount Aggregate';
    finding: 'aggregate';
    setting: 'umbrellaLiability_policyAmountAggregate';
  } = {
    label: 'Policy Amount Aggregate',
    finding: 'aggregate',
    setting: 'umbrellaLiability_policyAmountAggregate'
  };
  umbIsAgency: {
    label: 'Waiver of Subrogation Checked?';
    finding: 'subrWvd';
    setting: 'umbIsAgency';
  } = {
    label: 'Waiver of Subrogation Checked?',
    finding: 'subrWvd',
    setting: 'umbIsAgency'
  };
  umbIsNamed: {
    label: 'Additional Insured';
    finding: 'addlInsured';
    setting: 'umbIsNamed';
  } = {
    label: 'Additional Insured',
    finding: 'addlInsured',
    setting: 'umbIsNamed'
  };
  umbrellaLiability_hasPolicyDoc: {
    label: 'Has Passed Full Policy Review?';
    finding: 'hasPolicyDoc';
    setting: 'umbrellaLiability_hasFullPolicyDoc';
  } = {
    label: 'Has Passed Full Policy Review?',
    finding: 'hasPolicyDoc',
    setting: 'umbrellaLiability_hasFullPolicyDoc'
  };
  umbrellaLiability_hasDescOps: {
    label: 'Description of Operations Validated?';
    finding: 'hasDescOps';
    setting: 'umbDescOps';
  } = {
    label: 'Description of Operations Validated?',
    finding: 'hasDescOps',
    setting: 'umbDescOps'
  };
  umbrellaLiability_hasRequiredForms: {
    label: 'Has Required Forms?';
    finding: 'hasRequiredForms';
    setting: 'umbrellaLiability_hasRequiredForms';
  } = {
    label: 'Has Required Forms?',
    finding: 'hasRequiredForms',
    setting: 'umbrellaLiability_hasRequiredForms'
  };
  umbPrimaryNonContributory: {
    label: 'Primary & Non-Contributory?';
    finding: 'hasPnc';
    setting: 'umbrellaLiability_primaryNonContributory';
  } = {
    label: 'Primary & Non-Contributory?',
    finding: 'hasPnc',
    setting: 'umbrellaLiability_primaryNonContributory'
  };
  umbOccurrenceBased: {
    label: 'Occurrence Based?';
    finding: 'occurrenceBased';
    setting: 'umbrellaLiability_occurrenceBased';
  } = {
    label: 'Occurrence Based?',
    finding: 'occurrenceBased',
    setting: 'umbrellaLiability_occurrenceBased'
  };
  umbrellaLiability_InsNameFailed: {
    label: 'Insured Name?';
    finding: 'InsNameFailed';
    setting: 'umbrellaLiability_InsNameFailed';
  } = {
    label: 'Insured Name?',
    finding: 'InsNameFailed',
    setting: 'umbrellaLiability_InsNameFailed'
  };
  umbrellaLiability_legalNameMismatch: {
    label: 'COI Name/Legal Name Mismatch?';
    finding: 'legalNameMismatch';
    setting: 'umbrellaLiability_legalNameMismatch';
  } = {
    label: 'COI Name/Legal Name Mismatch?',
    finding: 'legalNameMismatch',
    setting: 'umbrellaLiability_legalNameMismatch'
  };

  workersCompensation_amBestRating: {
    label: 'AM Best Rating';
    finding: 'amBestRating';
    setting: 'workersCompensation_amBestRating';
  } = {
    label: 'AM Best Rating',
    finding: 'amBestRating',
    setting: 'workersCompensation_amBestRating'
  };
  workersCompensation_financialSizeCategory: {
    label: 'AM Best Financial Size Category';
    finding: 'financialSize';
    setting: 'workersCompensation_financialSizeCategory';
  } = {
    label: 'AM Best Financial Size Category',
    finding: 'financialSize',
    setting: 'workersCompensation_financialSizeCategory'
  };
  workersCompensation_eachIncidentEmployersLimit: {
    label: 'E.L. Each Accident';
    finding: 'elEachAccident';
    setting: 'workersCompensation_eachIncidentEmployersLimit';
  } = {
    label: 'E.L. Each Accident',
    finding: 'elEachAccident',
    setting: 'workersCompensation_eachIncidentEmployersLimit'
  };
  workersCompensation_eachEmployeeMinimum: {
    label: 'E.L. Disease - EA Employee';
    finding: 'elDiseaseEachEmployee';
    setting: 'workersCompensation_eachEmployeeMinimum';
  } = {
    label: 'E.L. Disease - EA Employee',
    finding: 'elDiseaseEachEmployee',
    setting: 'workersCompensation_eachEmployeeMinimum'
  };
  workersCompensation_eachEmployerMinimum: {
    label: 'E.L. Disease - Policy Limit';
    finding: 'elDiseasePerPolicy';
    setting: 'workersCompensation_eachEmployerMinimum';
  } = {
    label: 'E.L. Disease - Policy Limit',
    finding: 'elDiseasePerPolicy',
    setting: 'workersCompensation_eachEmployerMinimum'
  };
  wkIsAgency: {
    label: 'Waiver of Subrogation Checked?';
    finding: 'subrWvd';
    setting: 'wkIsAgency';
  } = {
    label: 'Waiver of Subrogation Checked?',
    finding: 'subrWvd',
    setting: 'wkIsAgency'
  };
  workersCompensation_hasDescOps: {
    label: 'Description of Operations Validated?';
    finding: 'hasDescOps';
    setting: 'wkDescOps';
  } = {
    label: 'Description of Operations Validated?',
    finding: 'hasDescOps',
    setting: 'wkDescOps'
  };
  workersCompensation_hasRequiredForms: {
    label: 'Has Required Forms?';
    finding: 'hasRequiredForms';
    setting: 'workersCompensation_hasRequiredForms';
  } = {
    label: 'Has Required Forms?',
    finding: 'hasRequiredForms',
    setting: 'workersCompensation_hasRequiredForms'
  };
  workersCompensation_officerExcluded: {
    label: 'Officer Exclusion?';
    finding: 'officerExcluded';
    setting: 'workersCompensation_officerExclusionNotAllowed';
  } = {
    label: 'Officer Exclusion?',
    finding: 'officerExcluded',
    setting: 'workersCompensation_officerExclusionNotAllowed'
  };
  workersCompensation_InsNameFailed: {
    label: 'Insured Name?';
    finding: 'InsNameFailed';
    setting: 'workersCompensation_InsNameFailed';
  } = {
    label: 'Insured Name?',
    finding: 'InsNameFailed',
    setting: 'workersCompensation_InsNameFailed'
  };
  workersCompensation_legalNameMismatch: {
    label: 'COI Name/Legal Name Mismatch?';
    finding: 'legalNameMismatch';
    setting: 'workersCompensation_legalNameMismatch';
  } = {
    label: 'COI Name/Legal Name Mismatch?',
    finding: 'legalNameMismatch',
    setting: 'workersCompensation_legalNameMismatch'
  };

  errorsAndOmissions_amBestRating: {
    label: 'AM Best Rating';
    finding: 'amBestRating';
    setting: 'errorsAndOmissions_amBestRating';
  } = {
    label: 'AM Best Rating',
    finding: 'amBestRating',
    setting: 'errorsAndOmissions_amBestRating'
  };
  errorsAndOmissions_financialSizeCategory: {
    label: 'AM Best Financial Size Category';
    finding: 'financialSize';
    setting: 'errorsAndOmissions_financialSizeCategory';
  } = {
    label: 'AM Best Financial Size Category',
    finding: 'financialSize',
    setting: 'errorsAndOmissions_financialSizeCategory'
  };
  errorsAndOmissions_policyAmount: {
    label: 'Professional Liability Per Occurrence';
    finding: 'perOccurence';
    setting: 'errorsAndOmissions_policyAmount';
  } = {
    label: 'Professional Liability Per Occurrence',
    finding: 'perOccurence',
    setting: 'errorsAndOmissions_policyAmount'
  };
  errIsNamed: {
    label: 'Additional Insured';
    finding: 'addlInsured';
    setting: 'errIsNamed';
  } = {
    label: 'Additional Insured',
    finding: 'addlInsured',
    setting: 'errIsNamed'
  };
  errIsAgency: {
    label: 'Waiver of Subrogation Checked?';
    finding: 'subrWvd';
    setting: 'errIsAgency';
  } = {
    label: 'Waiver of Subrogation Checked?',
    finding: 'subrWvd',
    setting: 'errIsAgency'
  };
  errorsAndOmissions_hasDescOps: {
    label: 'Description of Operations Validated?';
    finding: 'hasDescOps';
    setting: 'errDescOps';
  } = {
    label: 'Description of Operations Validated?',
    finding: 'hasDescOps',
    setting: 'errDescOps'
  };
  professionalLiability_InsNameFailed: {
    label: 'Insured Name?';
    finding: 'InsNameFailed';
    setting: 'professionalLiability_InsNameFailed';
  } = {
    label: 'Insured Name?',
    finding: 'InsNameFailed',
    setting: 'professionalLiability_InsNameFailed'
  };
  professionalLiability_legalNameMismatch: {
    label: 'COI Name/Legal Name Mismatch?';
    finding: 'legalNameMismatch';
    setting: 'professionalLiability_legalNameMismatch';
  } = {
    label: 'COI Name/Legal Name Mismatch?',
    finding: 'legalNameMismatch',
    setting: 'professionalLiability_legalNameMismatch'
  };
}
